'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enc = exports.enc = function enc(hour, part) {
  return hour * 1 + (part === 'pm' ? 12 : 0);
};

var dec = exports.dec = function dec(hour) {
  if (hour === undefined) return {
    hour: null,
    dayPart: null
  };
  var numericHour = hour * 1;
  return {
    hour: numericHour - (numericHour > 12 ? 12 : 0),
    dayPart: numericHour > 12 ? 'pm' : 'am'
  };
};